const store = {
  username: '无名氏',
  type: 'new-user', // new-user, old-user, friend
  region: '华东一区',
  level: 0,
  isRewarded: false,
  hero: '',
  quilt: 0,
  temp: 10,
  prize: 0,
  friends: [],
  reset: function() {
    this.hero = ''
    this.quilt = 0
    this.temp = 10
    this.prize = 0
  },
}

window._store = store

export default store
